/**
 * Responsible for creating an toggleContent based on elements existing in the DOM
 * @module toggleContent
 */

import Keyboard from './keyboard';

import $ from 'jquery';
import difference from 'lodash/difference';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options';

export const PLUGIN_NAME = 'toggleDisplay';
export const CLICK_EVENT = 'click';
export const ACTIVE_CLASS = 'is-active';
export const OVERLAY_CLASS = 'page-header__dropdown-overlay';
export const OVERLAY_ACTIVE_CLASS = `${OVERLAY_CLASS}--active`;
export const PAGE_CONSTRAIN_CLASS = 'page-constrain';
export const CHANGE_HANDLER = 'change';

const $bodyAndHtml = $("html, body");
const $html = $('html');
const $plpHeaderDropdown = $('#plpheader_dropdown');


export const DEFAULTS = {
  speed: 500,
  returnFocus: '',
  trapFocusFunc: Keyboard.trapFocus.bind(Keyboard),
  releaseFocusFunc: Keyboard.releaseFocus.bind(Keyboard),
};

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, toggleDisplay);

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
export default function toggleDisplay(el, options = {}) {
  var $el = $(el);
  var opts = mergeOptions(DEFAULTS, options, $el);
  var $toggleThis = $el.data('toggle-select-this');
  var $toggleShow = $el.data('toggle-select-show');
  var $toggleHide = $el.data('toggle-select-hide');
  var $animationType = $el.data('toggle-select-animation');
  var $includeOverlay = $el.data('overlay');
  var $overlay;
  var $isCategoryDropdown = $el.data('category-dropdown');
  if ($includeOverlay) {
    $overlay = addOverlay($el, options, $toggleThis);
  }
  applyEventHandlers($el, $toggleThis, $overlay, $isCategoryDropdown, $toggleShow, $toggleHide, $animationType, opts);
}

function addOverlay($el, options, $toggleThis) {
  var $modal = $(`<div class='page-header__dropdown-overlay'></div>`);
  return $modal.insertBefore($toggleThis);
}

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const toggler = ($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE) => {
  if (ANIMATION_TYPE === 'pop') {
    $(TOGGLE_SHOW).show();
    $(TOGGLE_HIDE).hide();
  } else {
    $(TOGGLE_SHOW).slideDown();
    $(TOGGLE_HIDE).slideUp();
  }
};

/**
 * Applies any sort of event handlers for the toggleContent.
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function applyEventHandlers($el, $toggleThis, $overlay, $isCategoryDropdown, $toggleShow, $toggleHide, $animationType, opts) {
  opts = opts || {};
    $el
    .on(CLICK_EVENT, function(evt) {
      evt.stopPropagation();
      if($toggleThis){
        selfToggler(evt, $el, $toggleThis, $overlay, $isCategoryDropdown, $animationType, opts);
      } else {
        toggler($el, $toggleShow, $toggleHide, $animationType, opts)
      }
    });

    $('html, body').on(CLICK_EVENT, function(evt) {
      if ($(evt.target).is($el) || $(evt.target).closest($toggleThis).length) {
        return;
      }
      if ($('.page-header__dropdown-overlay--active').length > 0) {
        evt.stopPropagation();
        closeToggle($el, $toggleThis, $overlay, $isCategoryDropdown, $animationType, opts);
      }
  });
  $el.on(CHANGE_HANDLER, () => {
    const selectedOption = $el.find(':selected');
    const $showElements = $(selectedOption.attr('data-toggle-select-show'));
    const $hideElements = $(selectedOption.attr('data-toggle-select-hide'));
    const $animationType = selectedOption.attr('data-toggle-select-animation');
    if ($showElements && $hideElements) {
      toggler(selectedOption, $showElements, $hideElements, $animationType, options);
    }
  });
}

/**
 * if active, close toggles
 */
function closeToggle($el, TOGGLE_THIS, OVERLAY, $isCategoryDropdown, ANIMATION_TYPE, opts) {
  if (ANIMATION_TYPE === 'slide') {
    $el.attr('aria-expanded', 'false')
    $(TOGGLE_THIS).slideUp();
  } else if (ANIMATION_TYPE === 'pop') {
    $el.attr('aria-expanded', 'false')
    $(TOGGLE_THIS).hide();
  }
  $(TOGGLE_THIS).removeClass(ACTIVE_CLASS);
  $el.removeClass(ACTIVE_CLASS);
  if ($isCategoryDropdown) {
    $el.attr('aria-expanded', "false");
    $plpHeaderDropdown.attr('aria-modal', "false");
    // If client is tabbing
    if ($html.hasClass('focus-active')){
      opts.releaseFocusFunc($el.parent('.js-page-header'), $(opts.returnFocus));
    }
  }
  if (OVERLAY) {
    $(OVERLAY).removeClass(OVERLAY_ACTIVE_CLASS);
  }
  $bodyAndHtml.removeClass(PAGE_CONSTRAIN_CLASS);
}
/**
 * Handles the click event when a label has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} opts - Options passed along from initialization
 */
function selfToggler(e, $el, TOGGLE_THIS, OVERLAY, $isCategoryDropdown, ANIMATION_TYPE, opts) {
  if ($el.hasClass(ACTIVE_CLASS)) {
    closeToggle($el, TOGGLE_THIS, OVERLAY, $isCategoryDropdown, ANIMATION_TYPE, opts)
  } else {
    closeOtherToggles($el);
    if (ANIMATION_TYPE === 'slide') {
      $el.attr('aria-expanded', 'true')
      $(TOGGLE_THIS).slideDown();
    } else if (ANIMATION_TYPE === 'pop') {
      $el.attr('aria-expanded', 'true')
      $(TOGGLE_THIS).show();
    }
    $(TOGGLE_THIS).addClass(ACTIVE_CLASS);
    $el.addClass(ACTIVE_CLASS);
    if ($isCategoryDropdown) {
      $el.attr('aria-expanded', "true");
      $plpHeaderDropdown.attr('aria-modal', "true");
      // If client is tabbing
      if ($html.hasClass('focus-active')) {
        opts.trapFocusFunc($el.parent('.js-page-header'));
      }
      // If close link is not present then create it and bind closeOtherToggles event to it
      if ($('#plp-close-link').length <= 0) {
        const plpList = document.getElementById('plp-dropdown-section');
        const closeMenuLink = createCloseMenu();
        plpList.appendChild(closeMenuLink);
        document.getElementById('plp-close-link').addEventListener('click', closeOtherToggles);
      } else {
        document.getElementById('plp-close-link').addEventListener('click', closeOtherToggles);
      }
    }
    if (OVERLAY) {
      $(OVERLAY).addClass(OVERLAY_ACTIVE_CLASS);
    }
    $bodyAndHtml.addClass(PAGE_CONSTRAIN_CLASS);
  }
}

function closeOtherToggles(elementToRemove) {
  var elements = $('.js-constrain-page.is-active');
  const diff = difference(elements, elementToRemove);
  diff.map((el) => {
    $(el).click();
  });
  // if PLP header dropdown
  if (elements.parents('#plpheader_dropdown')){
    var $this = $(this);
    var focusElement = $this.closest();
    $('#plp-dropdown').focus();
  }
}
// Create a Close Menu link for dropdown
function createCloseMenu() {
  const listItem = document.createElement('li');
  listItem.classList.add('ui-list__item', 'page-header__link', 'u-padding-rl--xxl');
  const buttonTag = document.createElement('button');
  buttonTag.classList.add('action-button', 'action-button--full', 'page-header__link--close');
  buttonTag.setAttribute('id', 'plp-close-link');
  buttonTag.innerHTML = 'Close Menu<span class="u-screen-reader">dropdown</span>';
  listItem.appendChild(buttonTag);
  return listItem;
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-display.js